if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.container = this.querySelector('.product-media-modal__content');
        this.slides = [];
        this.prevBtn = this.querySelector('.product-media-modal__nav--prev');
        this.nextBtn = this.querySelector('.product-media-modal__nav--next');
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.counterTotal = this.querySelector('.product-media-modal__counter-total');
        this.currentIndex = 0;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goToSlide(this.currentIndex - 1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goToSlide(this.currentIndex + 1);
          });
        }

        if (this.container) {
          let touchStartX = 0;
          let touchDeltaX = 0;
          let isSwiping = false;

          this.container.addEventListener('touchstart', (e) => {
            if (e.touches && e.touches.length === 1) {
              touchStartX = e.touches[0].clientX;
              touchDeltaX = 0;
              isSwiping = true;
            }
          }, { passive: true });

          this.container.addEventListener('touchmove', (e) => {
            if (isSwiping && e.touches && e.touches.length === 1) {
              touchDeltaX = e.touches[0].clientX - touchStartX;
            }
          }, { passive: true });

          this.container.addEventListener('touchend', () => {
            if (isSwiping && Math.abs(touchDeltaX) > 40) {
              if (touchDeltaX < 0) {
                this.goToSlide(this.currentIndex + 1);
              } else {
                this.goToSlide(this.currentIndex - 1);
              }
            }
            isSwiping = false;
            touchDeltaX = 0;
          }, { passive: true });

          this.container.addEventListener('scroll', () => {
            if (!this.container.clientWidth) return;
            const idx = Math.round(this.container.scrollLeft / this.container.clientWidth);
            if (idx !== this.currentIndex && idx >= 0 && idx < this.slides.length) {
              this.currentIndex = idx;
              this.syncActiveSlide();
              this.updateCounter();
            }
          }, { passive: true });
        }

        this.onKeyDown = (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goToSlide(this.currentIndex - 1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goToSlide(this.currentIndex + 1);
          }
        };
      }

      connectedCallback() {
        super.connectedCallback();
        window.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        window.removeEventListener('keydown', this.onKeyDown);
      }

      show(opener) {
        super.show(opener);
        this.initSlides();
        const mediaId = opener ? opener.getAttribute('data-media-id') : null;
        let targetIndex = 0;
        if (mediaId) {
          const found = this.slides.findIndex(s => s.getAttribute('data-media-id') === mediaId);
          if (found !== -1) targetIndex = found;
        }
        setTimeout(() => {
          this.goToSlide(targetIndex, 'instant');
        }, 50);
      }

      initSlides() {
        this.slides = Array.from(this.querySelectorAll('.product-media-modal__slide'));
        if (this.counterTotal) {
          this.counterTotal.textContent = this.slides.length || 1;
        }
        this.syncActiveSlide();
        this.updateCounter();
      }

      syncActiveSlide() {
        this.slides.forEach((s, i) => {
          if (i === this.currentIndex) {
            s.classList.add('active');
            s.style.display = 'flex';
          } else {
            s.classList.remove('active');
            s.style.display = 'flex';
          }
        });
      }

      goToSlide(index, behavior = 'smooth') {
        if (!this.slides.length) this.initSlides();
        if (this.slides.length === 0) return;
        if (index < 0) index = this.slides.length - 1;
        if (index >= this.slides.length) index = 0;
        this.currentIndex = index;
        this.syncActiveSlide();

        const targetSlide = this.slides[index];
        if (this.container) {
          const scrollTarget = targetSlide ? targetSlide.offsetLeft : (index * this.container.clientWidth);
          this.container.scrollTo({
            left: scrollTarget,
            behavior: behavior === 'instant' ? 'instant' : 'smooth'
          });
        }
        this.updateCounter();
      }

      updateCounter() {
        if (this.counterCurrent) {
          this.counterCurrent.textContent = (this.currentIndex + 1);
        }
      }
    }
  );
}
